import React from "react";
import { useController } from "react-hook-form";

const Status = ({
	kind,
	children,
	checked,
	control,
	name,
	className,
	id,
	...rest
}) => {
	const { field } = useController({
		control,
		name,
		defaultValue: "",
	});
	return (
		<div
			className={`form-group pms-lead-status gap-15px ${kind} ${className}`}>
			<input
				type='radio'
				checked={checked}
				id={id}
				name={name}
				{...field}
				{...rest}
			/>
			<label htmlFor={id}>{children}</label>
		</div>
	);
};

export default Status;
